'use strict';

angular.module('table-settings', [
    'ngCookies',
]);
